// src/firebaseConfig.js
const firebaseConfig = {
  apiKey: "AIzaSyAE54N1u1k8_Lq7p1PQhD_0lSo_MUW6kHU",
  authDomain: "optimizesignportal.firebaseapp.com",
  projectId: "optimizesignportal",
  storageBucket: "optimizesignportal.firebasestorage.app",
  messagingSenderId: "548800093647",
  appId: "1:548800093647:web:94ea293af06f8eaba8c6ba",
  measurementId: "G-X48BF4NBWL"
};
export default firebaseConfig;
